<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{ color }}-1">
						<h4 class="card-title d-flex align-items-center">
							<mat-icon class="mr-2 cursor-pointer" (click)="back()">arrow_back</mat-icon>
							GL impact
						</h4>
						<p class="card-category d-flex flex-wrap align-items-start justify-content-between">

							<button
								mat-stroked-button
								color="primary"
								type="button"
								class="ml-auto mr-0 flex-shrink-0"
								(click)="loadSystypes()"
								[disabled]="isLoading">
								Refresh
							</button>
						</p>
					</div>
					<div class="card-body">
						<div *ngIf="loadError" class="alert alert-danger" role="alert">{{ loadError }}</div>

						<div class="col-md-12 text-center py-4" *ngIf="isLoading">
							<svg class="spinner" width="48px" height="48px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
								<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
							</svg>
							<p class="text-muted mt-2 mb-0">Loading transaction types…</p>
						</div>

						<div class="table-responsive" *ngIf="!isLoading && systypes.length">
							<table mat-table [dataSource]="systypes" class="gl-impact-table w-100">
								<ng-container matColumnDef="typeid">
									<th mat-header-cell *matHeaderCellDef scope="col">Type</th>
									<td mat-cell *matCellDef="let row">{{ row.typeid }}</td>
								</ng-container>
								<ng-container matColumnDef="typename">
									<th mat-header-cell *matHeaderCellDef scope="col">Name</th>
									<td mat-cell *matCellDef="let row">{{ row.typename }}</td>
								</ng-container>
								<ng-container matColumnDef="typeno">
									<th mat-header-cell *matHeaderCellDef scope="col">Next no.</th>
									<td mat-cell *matCellDef="let row">{{ row.typeno }}</td>
								</ng-container>
								<ng-container matColumnDef="glImpact">
									<th mat-header-cell *matHeaderCellDef scope="col">GL data</th>
									<td mat-cell *matCellDef="let row">
										<span [class]="glImpactClass(row)" [attr.title]="row.gl_impact_status === 'unknown' ? 'No gltrans rows yet; module may be unused.' : null">
											{{ glImpactLabel(row) }}
										</span>
									</td>
								</ng-container>
								<ng-container matColumnDef="actions">
									<th mat-header-cell *matHeaderCellDef scope="col" class="col-actions">Actions</th>
									<td mat-cell *matCellDef="let row" class="col-actions">
										<button mat-stroked-button color="primary" type="button" (click)="openPreview(row)">
											Preview GL
										</button>
									</td>
								</ng-container>

								<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
								<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
							</table>
						</div>

						<p *ngIf="!isLoading && !systypes.length && !loadError" class="text-center text-muted mb-0 py-4">
							No systypes found.
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
